import { $Q } from 'graditify-utils'
const Shopify = window.Shopify

Shopify.queryParams = {}

/**
 * Update sort_by query parameter on select change
 */
export const sortBy = () => {
  $Q('#sort-by-js')
    .addEventListener(
      'change',
      ({ target }) => {
        Shopify.queryParams.sort_by = target.value
        location.search = new URLSearchParams(Shopify.queryParams).toString()
      })
}
